import { tr } from "../../i18n";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthLayout, { Field, ErrorNote, inputCls } from "./AuthLayout";
import { useAuth, apiError } from "../../auth/AuthContext";
export default function Login() {
  const {
    lang = "en"
  } = useParams();
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.must_change_password) {
        navigate(`/${lang}/change-password`);
      } else {
        navigate(`/${lang}/${user.role === "admin" ? "admin" : "portal"}`);
      }
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };
  return <AuthLayout title={tr("Login")} subtitle={tr("Sign in to your ESAIA portal.")}>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <ErrorNote error={error} />
        <Field label={tr("Email")} required htmlFor="login-email">
          <input id="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className={inputCls} data-testid="login-email-input" autoComplete="email" />
        </Field>
        <Field label={tr("Password")} required htmlFor="login-password">
          <input id="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" autoComplete="current-password" />
        </Field>
        <button type="submit" disabled={loading} data-testid="login-form-submit-button" className="w-full bg-esaia-blue px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark disabled:opacity-60">
          {loading ? tr("Signing in...") : tr("Log In")}
        </button>
        <div className="flex items-center justify-between pt-1 text-xs">
          <Link to={`/${lang}/forgot-password`} className="font-semibold text-esaia-blue hover:underline" data-testid="forgot-password-link">{tr("Forgot Password?")}{" "}</Link>
          <Link to={`/${lang}/register`} className="font-semibold text-esaia-muted hover:text-esaia-blue" data-testid="create-account-link">{tr("Create Account")}{" "}</Link>
        </div>
      </form>
    </AuthLayout>;
}
